module.exports = __webpack_public_path__ + "static/ulastirma-sol-050410a26225287fd36e656fcb42811b.png";